export type Currency = [Code: string, DecimalCount: number];

export const KUWAITI_DINAR: Currency = ["kwd", 3];

export type DecimalStrategy = "currency_default" | "trim_zeros";
